// Базовые цвета и конфигурация
const baseTheme = {
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem'
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    pill: '50rem'
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease'
  }
};

// Светлая тема
const lightTheme = {
  ...baseTheme,
  colors: {
    // Основные цвета
    primary: '#007bff',
    secondary: '#6c757d',
    success: '#28a745',
    danger: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
    
    // Фоны
    background: '#ffffff',
    surface: '#f8f9fa',
    card: '#ffffff',
    header: '#ffffff',
    
    // Текст
    text: '#212529',
    textSecondary: '#6c757d',
    textMuted: '#999999',
    
    // Границы
    border: '#dee2e6',
    borderLight: '#e9ecef',
    
    // Интерактивные элементы
    hover: '#f8f9fa',
    active: '#e9ecef',
    focus: '#007bff',
    
    // Состояния
    disabled: '#e9ecef',
    placeholder: '#6c757d',
    
    // Специальные
    white: '#ffffff',
    black: '#000000',
    
    gray: {
      100: '#f8f9fa',
      200: '#e9ecef',
      300: '#dee2e6',
      400: '#ced4da',
      500: '#adb5bd',
      600: '#6c757d',
      700: '#495057',
      800: '#343a40',
      900: '#212529'
    }
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.1)',
    focus: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'
  }
};

// Темная тема
const darkTheme = {
  ...baseTheme,
  colors: {
    // Основные цвета (более яркие для лучшей видимости)
    primary: '#4dabf7',
    secondary: '#adb5bd',
    success: '#51cf66',
    danger: '#ff6b6b',
    warning: '#ffd43b',
    info: '#74c0fc',
    
    // Фоны
    background: '#121212',
    surface: '#1e1e1e',
    card: '#2d2d2d',
    header: '#1a1a1a',
    
    // Текст
    text: '#ffffff',
    textSecondary: '#b3b3b3',
    textMuted: '#888888',
    
    // Границы
    border: '#404040',
    borderLight: '#333333',
    
    // Интерактивные элементы
    hover: '#2d2d2d',
    active: '#404040',
    focus: '#4dabf7',
    
    // Состояния
    disabled: '#333333',
    placeholder: '#888888',
    
    // Специальные
    white: '#ffffff',
    black: '#000000',
    
    gray: {
      100: '#2d2d2d',
      200: '#333333',
      300: '#404040',
      400: '#555555',
      500: '#777777',
      600: '#999999',
      700: '#b3b3b3',
      800: '#cccccc',
      900: '#ffffff'
    }
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.3)',
    md: '0 4px 6px rgba(0, 0, 0, 0.4)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.4)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.5)',
    focus: '0 0 0 0.2rem rgba(77, 171, 247, 0.25)'
  }
};

// Функция для получения текущей темы
export const getTheme = (isDarkMode) => {
  return isDarkMode ? darkTheme : lightTheme;
};

// Экспорт отдельных тем
export { lightTheme, darkTheme };

// Дефолтный экспорт (светлая тема для обратной совместимости)
export default lightTheme; 